import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-436801b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "mb-1 d-block" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = { class: "form-control numeric" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "col-md-3 apply" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "me-1" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-dash-circle-fill" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "ms-1" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle-fill" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_numeric_fld_input = _resolveComponent("numeric-fld-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("strong", _hoisted_2, _toDisplayString(_ctx.inputValue.ProductName), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.language.rem_qty), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.inputValue.RemainingQty)), 1)
      ]),
      _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.language.to_deliver), 1),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "btn-action",
              type: "button",
              disabled: !_ctx.isSubPossible,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.subOper && _ctx.subOper(...args)))
            }, _hoisted_13, 8, _hoisted_11)
          ]),
          _createVNode(_component_numeric_fld_input, {
            modelValue: _ctx.inputValue.ToDeliverQty,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValue.ToDeliverQty) = $event)),
            class: "flex-fill",
            onChange: _ctx.changeManualValue
          }, null, 8, ["modelValue", "onChange"]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              class: "btn-action",
              type: "button",
              disabled: !_ctx.isAddPossible,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addOper && _ctx.addOper(...args)))
            }, _hoisted_17, 8, _hoisted_15)
          ])
        ])
      ])
    ]),
    _hoisted_18
  ]))
}